export const DATA_KEY_GRID_ID = `mpse__editor__grid_sticker_editor__base__const__grid_id`;
